import { Box, IconButton } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import FormRenderer from '../FormRenderer/FormRenderer';

// Opt-in only — most Array fields (subscription plans, talktime plans, ...) let every
// element be freely deleted and edited regardless of whether it was there on load. A
// caller passes `disableExistingSlugs` (e.g. `['level']`) when specific fields shouldn't
// change on an element that already existed, without affecting any other consumer.
function BuzzArray({
  id,
  label,
  arrayElementType,
  value,
  onChange,
  disableExistingSlugs = [],
}) {
  const [arrayData, setArrayData] = useState([]);
  // Captured once on mount: elements present at that point are "existing"; anything
  // appended afterward, in this same session, is new and stays fully editable/removable.
  const existingCountRef = useRef(0);

  useEffect(() => {
    if (!value) {
      addNewElement();
    } else {
      existingCountRef.current = value.length;
      // Cloned rather than stored as-is: `value` can come straight from Redux state,
      // which Immer freezes in development — mutating one of its elements later (see
      // `handleSetArrayData`) would throw "Cannot assign to read only property".
      setArrayData(value.map((item) => ({ ...item })));
    }
  }, []);

  const addNewElement = () => {
    const newArrayElement = {};
    arrayElementType.map((obj) => {
      if (obj.type === 'MultiSelect') newArrayElement[obj.slug] = [];
      else newArrayElement[obj.slug] = null;
    });
    setArrayData((state) => {
      const newState = [...state, newArrayElement];
      onChange(newState);
      return newState;
    });
  };

  const removeAnElement = (indexToRemove) => {
    setArrayData((state) => {
      const newState = state.filter((item, index) => index != indexToRemove);
      onChange(newState);
      return newState;
    });
  };

  const handleSetArrayData = (index, slug, newValue) => {
    setArrayData((state) => {
      // Builds a new array/element rather than mutating `state[index]` in place — that
      // element may be a frozen Redux object (see the clone in the effect above), and
      // even when it isn't, React state should be treated as immutable regardless.
      const newState = state.map((item, i) =>
        i === index ? { ...item, [slug]: newValue } : item
      );
      onChange(newState);
      return newState;
    });
  };

  return (
    <div>
      <p>{label}</p>
      <div
        style={{
          width: '100%',
          overflowX: 'auto',
        }}>
        <div
          style={{
            display: 'inline-flex',
            flexDirection: 'row',
            gap: '1rem',
            // backgroundColor: 'red',
          }}>
          {arrayData &&
            arrayData.map((data, index) => {
              const isExisting = index < existingCountRef.current;
              const locksThisElement = isExisting && disableExistingSlugs.length > 0;
              const elementTemplate = locksThisElement
                ? arrayElementType.map((field) =>
                    disableExistingSlugs.includes(field.slug)
                      ? { ...field, disabled: true }
                      : field
                  )
                : arrayElementType;

              return (
                <Box
                  id={id}
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.2)',
                    borderRadius: '5px',
                    width: '40%',
                    // backgroundColor: 'red',
                    flexGrow: 1,
                    minWidth: '250px',
                    padding: '0.5rem',
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <p>[{index + 1}]</p>{' '}
                    <IconButton
                      onClick={() => removeAnElement(index)}
                      disabled={locksThisElement}>
                      <DeleteIcon color="primary" />
                    </IconButton>
                  </div>

                  <FormRenderer
                    id={index}
                    formTemplate={elementTemplate}
                    formData={arrayData[index]}
                    setFormData={(slug, newValue) =>
                      handleSetArrayData(index, slug, newValue)
                    }
                  />
                </Box>
              );
            })}
          <button
            onClick={addNewElement}
            style={{
              border: '1px solid rgba(0, 0, 0, 0.2)',
              borderRadius: '5px',
              width: '250px',
              padding: '0.5rem',
              cursor: 'pointer',
            }}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
}

export default BuzzArray;
